// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2k0Nq","buttons":"RemoveExpirationActionButtons_buttons__1S9ZX"};